import {SxProps, Theme, Typography, TypographyProps} from "@mui/material";
import React from "react";
import {KeyHistoryRecord} from "../../api/Model";
import {toLocationTypeEnum} from "../location/KeyLocationShield";
import {today} from "../../util/DateUtil";

export function KeyHistoryPeriodEnd({record}: {
    record: KeyHistoryRecord | undefined,
}) {
    const expTo = record && toLocationTypeEnum(record.location).expectedReturnDate;

    const line: {
        line: string,
        title?: string,
        color?: TypographyProps['color'],
        sx?: SxProps<Theme>,
    } = !record ? {
        line: 'No active history record',
        sx: {fontWeight: 'bold', color: 'warning.main'},
    } : record.to ? {
        line: record.to,
    } : !expTo ? {
        line: 'permanent',
    } : expTo >= today() ? {
        line: expTo,
        title: `Expected return date`,
        sx: {color: 'text.disabled'},
    } : {
        line: expTo,
        title: `Expected return date has expired`,
        sx: {fontWeight: 'bold', color: 'warning.main'},
    };


    return (
        <Typography
            variant="inherit"
            component="span"
            color={line.color}
            title={line.title}
            sx={line.sx}
        >{line.line}</Typography>
    );
}

export function KeyHistoryPeriod({record}: {
    record: KeyHistoryRecord | undefined,
}) {
    return (
        <Typography variant="inherit">
            {record?.from && (
                <>{record.from}&nbsp;–&nbsp;</>
            )}
            <KeyHistoryPeriodEnd record={record}/>
        </Typography>
    );
}
